import React from "react";
import { ButtonRenderProps, ContentSection, LabeledText, Stack } from "sprint-common-web";

import { AncillaryComponentRenderer } from "../../../../../../common/components/AncillaryComponentRenderer";
import { MovieComponentRenderer } from "../../../../../../common/components/MovieComponentRenderer";
import { TvSeriesComponentRenderer } from "../../../../../../common/components/TvSeriesComponentRenderer";
import { FileRecordAncillaryContentView } from "../../../../../common/file-record-details/content/ancillary/FileRecordAncillaryContentView";
import { FileRecordMovieContentView } from "../../../../../common/file-record-details/content/movie/FileRecordMovieContentView";
import { FileRecordTvSeriesContentView } from "../../../../../common/file-record-details/content/tv-series/FileRecordTvSeriesContentView";
import { isFileRecordDetailsEditable } from "../../../../../common/file-record-details/FileRecordDetails";
import { EditContentButton, EditContentButtonProps } from "../../../../forms/edit/content/EditContentButton";
import { useFileRecordDetailsState } from "../../../hooks/useFileRecordDetailsState";

export const FileRecordContentSection = (): JSX.Element => {
    const { fileRecordDetails, isLoading } = useFileRecordDetailsState();

    const editContentButton: ButtonRenderProps<EditContentButtonProps> = {
        render: EditContentButton,
        disabled: !isFileRecordDetailsEditable(fileRecordDetails)
    };

    const buttons = [editContentButton];

    return (
        <ContentSection
            header="Content"
            testId="content-content-section"
            isLoading={isLoading}
            style={{ height: 400 }}
            buttons={buttons}
        >
            {fileRecordDetails.content ? (
                <Stack>
                    <MovieComponentRenderer subtype={fileRecordDetails.content.contentSubtype}>
                        <FileRecordMovieContentView fileRecordDetails={fileRecordDetails} />
                    </MovieComponentRenderer>
                    <TvSeriesComponentRenderer subtype={fileRecordDetails.content.contentSubtype}>
                        <FileRecordTvSeriesContentView fileRecordDetails={fileRecordDetails} />
                    </TvSeriesComponentRenderer>
                    <AncillaryComponentRenderer subtype={fileRecordDetails.content.contentSubtype}>
                        <FileRecordAncillaryContentView fileRecordDetails={fileRecordDetails} />
                    </AncillaryComponentRenderer>
                </Stack>
            ) : (
                <Stack>
                    <LabeledText label="Content" testId="content-field">
                        -
                    </LabeledText>
                </Stack>
            )}
        </ContentSection>
    );
};
